export default "//cloud.imgsmail.ru/cloud.mail.ru/178578/img/build/quota-landing/appStore.png";